import React from "react";

import Framework from "@beardeddevops/react.framework";
import API from "@beardeddevops/react.api";
import {Types} from "components";
import {Button} from "reactstrap";
import {Toast, ToastBody, ToastHeader} from 'reactstrap';
import CollectionOverride from "components/CollectionOverride";

/**
 @typedef {Object<any>} Locations_Modules
 @property {Locations_Modules_Properties} properties
 @property {Locations_Modules_Has} has
 @property {Locations_Modules_Is} is
 @property {Locations_Modules_Object} object
 */
export default class LocationAddOns extends CollectionOverride {
	constructor(props) {
		super(props, Types.Locations_Modules._name);
	}

	componentDidMount() {
		this.loadData();
	}

	loadData() {
		// noinspection JSIgnoredPromiseFromCall
		this.fetchData({
			pageSize: null,
			page: 0,
			sorted: []
		});
	}

	submitModule = (pkey, binary_id, module, account) => async () => {
		this.setState({loading: true});
		let moduleModel = new API.BuildClass(account ? Types.Accounts_Modules._name : Types.Locations_Modules._name, API.RequestType.READ);
		// noinspection JSValidateTypes
		moduleModel.object.pkey = pkey;
		moduleModel.object.binary_id = binary_id;

		if (!account) {
			moduleModel.parent = this.props.parent;
		}

		moduleModel.object.module = module;

		try {
			await moduleModel.submit(null, pkey ? API.RequestType.DELETE : API.RequestType.CREATE);
		} catch (e) {
		}

		this.setState({loading: false});
		this.loadData();
		this.props.reloadShell();
	}

	render = () => {
		let {loading, data} = this.state;

		return (
			<div>
				{data.map(
					/**
					 * @param {Locations_Modules_Object} subscription
					 * @param i
					 * @returns {*}
					 */
					(subscription, i) =>
						<div key={i} className={"p-7 " + (subscription.subscribed ? 'bg-info' : 'bg-success') + " my-2 rounded"}>
							<Toast style={{maxWidth: "100%"}}>
								<ToastHeader>
									<h3> {subscription.modules.description} - {subscription.subscribed ? 'Subscribed' : subscription.modules.price}</h3>
								</ToastHeader>
								{subscription.module !== 1 || !subscription.location || ['tadlite', 'tadbasic', 'tadproannual', 'tadplusannual', 'tadbasicannual', 'tadliteannual', 'tadmicroannual',
									'tadpro', 'tadplus', 'tadbasicnew', 'tadlitenew', 'tadmicro', 'ffl_home', 'ffl_plus'].indexOf(subscription.locations.type.toString()) !== -1 ?
									(
										subscription.subscribed ?
											<Button color={"primary"} style={{float: "right", margin: "5px .75rem"}}
											        onClick={this.submitModule(subscription.pkey, subscription.binary_id, subscription.module, subscription.modules.type === 2)}>
												<i className={"fa fa-tags"}/> Remove Module
											</Button> :
											<Button color={"primary"} style={{float: "right", margin: "5px .75rem"}}
											        onClick={this.submitModule(null, null, subscription.module, subscription.modules.type === 2)}>
												<i className={"fa fa-tags"}/> Add Module
											</Button>
									)
									:
									(subscription.locations.subscriptions &&
										<Button color={"warning"} style={{float: "right", margin: "5px .75rem"}}><i
											className={"fa fa-lock"}/> Included
											with {subscription.locations.subscriptions.description} Subscription </Button>)
								}
								<ToastBody>
									<p style={{marginBottom: '0'}}>{subscription.modules.note}</p>
									{subscription.modules.additional &&
									<p className={"text-muted"} style={{fontSize: "smaller", marginTop: "0px", marginBottom: '0'}}>
										{subscription.modules.additional}
									</p>}
								</ToastBody>
							</Toast>
						</div>
				)}

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}

}

